export default __webpack_public_path__ + "static/media/logo.ad6e188e.png";